export default class Mov {
    constructor() {
        this.init();
    }

    init() {
        this._getEl();
    }

    _getEl() {
        this.$mov = document.querySelector('.js-mov');

        this.$mov && this._setMov();
    }

    _setMov() {
        const $script = document.createElement('script');
        $script.src = 'https://www.youtube.com/iframe_api';

        document.body.append($script);

        window.onYouTubeIframeAPIReady = () => {
            this.player = new YT.Player('player');
        };

        this._stopMov();
    }

    _stopMov() {
        this.$mov.addEventListener('transitionend', e => {
            if (e.target.className != 'c-modal js-mov') return;
            this.player.stopVideo();
        });
    }

    loadMov(movId) {
        this.$mov && this.player.loadVideoById({ videoId: movId });
    }
}
